import axios from 'axios';
import {Message} from 'element-ui';
import {Storage} from '@/utils/common';

import router from '@/router';
const toLogin = () => {
  Storage.remove('token');
  router.replace('login');
};

const service = axios.create();
// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = Storage.get('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (['get', 'delete'].includes(config.method)) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    config.url = '/api' + config.url;
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 二进制数据则直接返回
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
      return res;
    }
    if ([10020001, '10020001'].includes(res.data.code)) {
      toLogin();
    }
    if (res.data.code !== 0) {
      const errMsg = res.data.msg || '服务未找到';
      // hideErrorTip默认为false或undefined，如果为true则不显示错误提示
      if (!res.config.hideErrorTip) {
        Message.error(errMsg);
      }
    }
    return res.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default service;
